import { customElement, containerless, autoinject, computedFrom } from 'aurelia-framework';
import { Router } from 'aurelia-router';


import './layout-template.scss';

@autoinject()
@containerless()
@customElement('mb-template')
export class LayoutTemplate {

  constructor(private router: Router) {
  }

  public contactUs(): void {
    this.router.navigate('contact-us');
  }

  @computedFrom('router.currentInstruction')
  public get isGallery(): boolean {
    return this.router.currentInstruction.config.name === 'gallery';
  }
}
